import VehiculesATarerController from './vehicules.a.tarer.controller';

export default {
    template: require('./vehicules.a.tarer.tpl.html'),
    controller: VehiculesATarerController
};
